<template>
  <div>
    <div class="mb-3">
      <div class="d-flex justify-end mb-3">
        <v-btn depressed color="var(--g)" @click="exportData" dark
          >Export</v-btn
        >
      </div>
      <v-row>
        <v-col cols="12" md="10">
          <v-text-field
            placeholder="Search Scholar"
            solo
            v-model="find"
            @keyup="fetchData"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
            depressed
            color="#016443"
            height="38px"
            @click="fetchData"
            dark
            block
          >
            <h5>Search</h5>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-skeleton-loader type="table-tbody" v-if="loading"></v-skeleton-loader>
      <div v-if="dataSet && !loading">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
          :single-select="false"
        >
          <template v-slot:[`item.created_at`]="{ item }">
            <h5 style="font-weight: normal">
              {{ $date(item.created_at).format("MMM DD, YYYY") }}
            </h5>
          </template>
          <template v-slot:[`item.scholar`]="{ item }">
            <router-link
              v-if="item.scholar"
              class="opener_name"
              :to="`/scholar/${item.scholar.user_id}`"
            >
              <p class="mb-0 black--text">{{ item.scholar.name }}</p>
            </router-link>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="blue"
                    icon
                    small
                    @click="updateSubmission(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Update</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="text-center pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
        <div class="pa-3">
          <dialog-large
            :d_large="d_large"
            @refetch="fetchData"
            @close="d_large = false"
            :inventory="inventory"
            :type="d_type"
            :title="d_title"
            line="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "moduleIpSub",
  data() {
    return {
      loading: false,
      dataSet: null,
      page: 1,
      limit: 10,
      tab: null,
      find: "",
      headers: [
        {
          text: "ID",
          align: "start",
          value: "scholar.no_tf",
        },
        {
          text: "Name",
          align: "start",
          value: "scholar",
        },
        {
          text: "Email",
          align: "start",
          value: "scholar.email",
        },
        {
          text: "Submitted Date",
          align: "start",
          value: "created_at",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/draft/get?page[number]=${this.page}&page[size]=${this.limit}&filter[search]=${this.find}&include=scholar`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateSubmission(item) {
      let obj = {};
      for (let key in item) {
        if (key.includes("semester")) {
          obj[key] = item[key];
        }
      }
      item["semester"] = obj;
      let data = {
        name: item.scholar.name,
        id_teladan: item.scholar.no_tf,
        data: item,
      };
      this.d_type = "u_submission_admin";
      this.d_title = "Edit Status Submission";
      this.d_large = true;
      this.inventory = data;
    },
    exportData() {
      let data = {
        path: `export/scholar-ip`,
        body: {
          "filter[search]": this.find,
        },
      };
      this.$store.dispatch("exportData", data);
    },
  },
};
</script>

<style>
</style>